import { c as _c } from "react/compiler-runtime";
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import type { Movie } from 'src/lib/movieinfo/movieinfotypes';
import styles from './KommerTextRow.module.css';
import { format, parseISO } from "date-fns";
import { locale } from "src/lib/locale/date-fns";
;
import WatchlistActionButton from 'src/components/kommendefilmer/WatchlistActionButton';
import withWatchlistState from 'src/components/filmwebid/withWatchlistState';
import { getMovieIdentifier } from 'src/lib/filmwebid/useMovieIdentifier';
import getThemeStyles from "src/lib/styling/getThemeStyles";
import classNames from "classnames";

//#region [Props]
type KommerTextRowProps = {
  dateFormat: "thisweek" | "thisyear" | "year";
  film: Movie;
};
//#endregion

//#region [Component]
export default function KommerTextRow(t0) {
  const $ = _c(21);
  const {
    dateFormat,
    film
  } = t0;
  if (!film.premiere) {
    return null;
  }
  let dateLabel;
  if ($[0] !== dateFormat || $[1] !== film.isPremiereConfirmed || $[2] !== film.premiere) {
    const premDate = parseISO(film.premiere);
    if (film.isPremiereConfirmed) {
      bb0: switch (dateFormat) {
        case "thisyear":
        case "thisweek":
          {
            dateLabel = format(premDate, "EEEE dd. MM", {
              locale
            });
            break bb0;
          }
        case "year":
          {
            dateLabel = format(premDate, "dd.MM.yyyy", {
              locale
            });
          }
      }
    } else {
      dateLabel = format(premDate, "MMM. yyyy");
    }
    $[0] = dateFormat;
    $[1] = film.isPremiereConfirmed;
    $[2] = film.premiere;
    $[3] = dateLabel;
  } else {
    dateLabel = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    const themeValues = getThemeStyles(styles);
    t1 = classNames(styles.SRowArticle, themeValues);
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = `/film/${film.mainVersionId}`;
  let t3;
  if ($[5] !== film.title) {
    t3 = <h2 className={styles.SMovieTitle}>{film.title}</h2>;
    $[5] = film.title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <FilmwebLink className={styles.STitleLink} to={t2}>{t3}</FilmwebLink>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== dateLabel) {
    t5 = <div className={styles.SPremiere}>{dateLabel}</div>;
    $[10] = dateLabel;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== film) {
    t6 = getMovieIdentifier(film);
    $[12] = film;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <WLSWatchlistButton className={styles.SWLSWatchlistButton} movieIdentifier={t6} hideLabel={true} />;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t4 || $[18] !== t5 || $[19] !== t7) {
    t8 = <article className={t1}>{t4}{t5}{t7}</article>;
    $[16] = t1;
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
//#endregion

const WLSWatchlistButton = withWatchlistState(WatchlistActionButton);

//#region [Styles]
// migrated to KommerTextRow.module.css
//#endregion